import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import { useExport } from "./hooks";
import ExportForm from "./form/export-form";
import { useUser } from "./../../../common-hooks/user";

const ExportComponent = (props) => {
  const {
    toggleModal,
    isOpenModal,
    isLoading,
    downloadUserReport,
    dateError,
    setDateError,
  } = useExport(props);

  const { isMember, isCoordinator } = useUser();

  if (isMember || isCoordinator) {
    return null;
  }

  return (
    <div>
      <Tooltip
        title="Download Users"
        placement="bottom"
        className="download__user_report"
      >
        <i
          className="fa fa-file-excel-o fa-2x icon-btn-action"
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <ExportForm
              isLoading={isLoading}
              downloadUserReport={downloadUserReport}
              dateError={dateError}
              setDateError={setDateError}
            />
          }
          title="Export Users"
        />
      ) : null}
    </div>
  );
};

export default ExportComponent;
